import '.a6{position:fixed;}.ssr-plugin'
import '.cv{top:0;}.ssr-plugin'
import '.bp{left:0px;}.ssr-plugin'
import '.bq{right:0px;}.ssr-plugin'
import '.f0{bottom:0px;}.ssr-plugin'
import '.hv{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.hw{z-index:998;}.ssr-plugin'
import '.hx{transition:opacity 0.3s ease;}.ssr-plugin'
import '.a0{height:100vh;}.ssr-plugin'
import '.ab{width:100%;}.ssr-plugin'
import '.ah{background-color:var(--shades-white);}.ssr-plugin'
import '.hy{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.hz{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.ac{justify-content:space-between;}.ssr-plugin'
import '.c3{padding:1.5rem;}.ssr-plugin'
import '.i0{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.b8{flex-shrink:0;}.ssr-plugin'
import '.ci{flex:1;}.ssr-plugin'
import '.ai{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="a6 cv bp bq f0 hv hw hx"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="a6 cv a0 ab ah hy hz a b"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a c ac c3 i0 b8"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="ci ai c3"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
